import React from 'react';
import styles from './Card.module.css';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties; // Added style prop to support inline styles
}

const Card: React.FC<CardProps> = ({ children, className, style }) => (
  <div className={`${styles.card}${className ? ` ${className}` : ''}`} style={style}>
    {children}
  </div>
);

const CardActions: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className }) => (
  <div className={`${styles['card-actions']}${className ? ` ${className}` : ''}`}>
    {children}
  </div>
);

export default Object.assign(Card, { Actions: CardActions });
